import { render, staticRenderFns } from "./DashboardGraphicArea.vue?vue&type=template&id=877e171a&"
import script from "./DashboardGraphicArea.vue?vue&type=script&lang=js&"
export * from "./DashboardGraphicArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports